import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { MoveFilesToFolder } from '../MoveFilesToFolder';
import { MoveFilesToFolderProps } from '../MoveFilesToFolder/MoveFilesToFolder.component';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';

import './MoveModal.styles.scss';
import './MoveModal.styles.responsive.scss';

const MoveModal: React.ForwardRefRenderFunction<
  ModalRef,
  MoveFilesToFolderProps
> = (props, ref) => {
  const { t } = useTranslation();
  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  useImperativeHandle(ref, () => modal, [modal]);

  const closeMoveFiles = useCallback(() => {
    props.closeMoveFiles();
    modal?.close();
  }, [modal, props]);

  return (
    <Modal
      ref={modalRef}
      lockScroll={false}
      onClose={props.closeMoveFiles}
      className="move-modal"
      title={t('moveNumberItems', { count: props.nodes.length })}
    >
      <MoveFilesToFolder
        {...props}
        isOpen={modal?.openState}
        closeMoveFiles={closeMoveFiles}
      />
    </Modal>
  );
};

export default forwardRef(MoveModal);
